<template>
  <div class="echartsBox">
    <div class="base-margin__bottom-10 base-flex">
      <!--  时间区间    -->
      <el-date-picker
        v-model="pickerValue"
        :clearable="false"
        :picker-options="pickerOptions"
        align="right"
        format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        @change="changePickerValue"
      >
      </el-date-picker>
      <!--  时间颗粒    -->
      <el-select
        v-model="selectOptionsValue"
        class="base-margin__left-8 select_width" placeholder="请选择" @change="changeSelectOptionsValue">
        <el-option
          v-for="item in selectOptions"
          v-show="item.show"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <!--   批次     -->
      <BatchIndex
        ref="batchIndex"
        :subclusterId="Number(this.$route.query.id)"
        class="base-margin__left-8 select_width"
        @filterSubclusterInstances="filterSubclusterInstances"
      />
    </div>
    <div class="echartsCollapse">
      <el-collapse v-model="activeNames">
        <el-collapse-item v-for="index in activeList.length" :key="index"
                          :name="activeList[index - 1].name" :title="activeList[index - 1].name">
          <echartsData :ref="activeList[index - 1].id"
                       :dayJsFormat="dayJsFormat"
                       :echartsId="activeList[index - 1].id"
                       :myLineCharDataList="myLineChartList[index - 1]"
                       :pickerValue="pickerValue"
                       :projectId="projectId"
                       :selectOptionsValue="selectOptionsValue"
                       :xAxisData="xAxisData"
          ></echartsData>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>

import dayjs from 'dayjs';
import {mapGetters, mapState} from 'vuex';
import {Message} from 'element-ui';
import {dateShortcuts, myLineChartList} from '@/components/echarts/constants';
import BatchIndex from '@/components/batchIndex/index.vue';
import echartsData from './IndexView.vue';
import {debounce} from '@/common/utils/utils';


export default {
  name: 'echarts',
  components: {
    echartsData,
    BatchIndex,
  },
  data() {
    return {
      activeList: [{
        name: 'CPU监控',
        id: 'cpuMonitoring',
      }, {
        name: '内存监控',
        id: 'memoryMonitoring',
      }, {
        name: '磁盘监控',
        id: 'diskMonitoring',
      }, {
        name: '网络监控',
        id: 'networkMonitoring',
      }],
      activeNames: ['CPU监控', '内存监控', '磁盘监控', '网络监控'],
      projectId: 0,
      pickerValue: [],
      pickerOptions: {
        disabledDate: (time) => {
          const day1 = 180 * 24 * 3600 * 1000;
          const minTime = new Date().getTime() - day1;
          const maxTime = new Date().getTime();
          return time.getTime() < minTime || time.getTime() > maxTime;
        },
        shortcuts: dateShortcuts,
      },
      myLineChartList,
      selectOptionsValue: 10,
      selectOptions: [{
        value: 10,
        label: '10秒',
        show: true,
      }, {
        value: 60,
        label: '1分钟',
        show: true,
      }, {
        value: 300,
        label: '5分钟',
        show: true,
      },
        //   {
        //   value: 600,
        //   label: '10分钟',
        //   show: true,
        // },
        {
          value: 3600,
          label: '1小时',
          show: true,
        }, {
          value: 86400,
          label: '一天',
          show: true,
        }],

      dayJsFormat: 'HH:mm',
      xAxisData: [],
      subclusterId: 0,
      batchIndexOptions: [],
      batchIndex: '',
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      if (currentProject.id !== this.projectId) {
        this.projectId = val.id;
        this.getEchartsData();
      }
      this.currentProject = currentProject;
    },
  },


  mounted() {
    const currentProject = this.getCurrentProject();
    this.projectId = currentProject.id;
    // 子集群id
    this.subclusterId = this.$route.query?.id || 0;

    this.$refs.batchIndex.getSubclusterInstances(Number(this.$route.query.id));

    // 默认获取一小时内的数据
    const startTime = dayjs().subtract(1, 'hour')
      .format('YYYY-MM-DD HH:mm:ss');
    const endTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
    this.pickerValue = [startTime, endTime];
    this.changePickerValue();
    const _this = this;
    window.onresize = function () {
      _this.echartsReSize();
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },

  methods: {
    // 窗口改变
    echartsReSize() {
      debounce(() => {
        for (let i = 0; i < this.activeList.length; i++) {
          this.$refs[this.activeList[i].id][0].init('resize');
        }
      }, 200);
    },

    filterSubclusterInstances(batchIndex) {
      this.batchIndex = batchIndex;
      this.getEchartsData();
    },
    /**
     * 获取数据
     */
    getEchartsData() {
      for (let i = 0; i < this.activeList.length; i++) {
        this.$refs[this.activeList[i].id][0].getEchartsData(this.pickerValue, this.selectOptionsValue, this.subclusterId, this.batchIndex, this.activeList[i].id);
      }
    },

    changeSelectOptionsValue() {
      this.filterTimeMargin();
      this.getEchartsData();
    },

    // 批次
    // getAllSubclusterActivityCreateBatchIndex() {
    //   if (!this.$route.query.id) {
    //     return;
    //   }
    //   const data = {
    //     subclusterId: Number(this.$route.query.id),
    //   };
    //   postRequest('/api/eda/common/subcluster/getAllSubclusterActivityCreateBatchIndex', data).then((res) => {
    //     res.subclusterActivityIndexList.forEach((item) => {
    //       this.batchIndexOptions.push(item.createBatchIndex);
    //     });
    //   });
    // },

    /**
     * 切换时间， 格式化选择项
     */
    async changePickerValue() {
      if (!this.pickerValue) return Message.error('请选择时间范围');
      const timeDiff = dayjs(this.pickerValue[1]).unix() - dayjs(this.pickerValue[0]).unix();
      // 时间不超过5分钟
      if (timeDiff <= 300) {
        this.selectOptions.map((item) => {
          if (item.value < 300) {
            item.show = true;
          } else {
            item.show = false;
          }
        });
        this.selectOptionsValue = 10;
        this.dayJsFormat = 'HH:mm:ss';
      }
      // 时间不超过1小时
      if (timeDiff > 300 && timeDiff <= 3600) {
        this.selectOptions.map((item) => {
          if (item.value < 600) {
            item.show = true;
          } else {
            item.show = false;
          }
        });
        this.selectOptionsValue = 300;
        this.dayJsFormat = 'HH:mm';
      }
      if (timeDiff > 3600 && timeDiff <= 86400) {
        this.selectOptions.map((item) => {
          if (item.value < 86400 && item.value > 10) {
            item.show = true;
          } else {
            item.show = false;
          }
        });
        this.dayJsFormat = 'HH:mm';
        this.selectOptionsValue = 3600;
      }
      // 时间超过一天 不超过一周
      if (timeDiff > 86400 && timeDiff <= 604800) {
        this.selectOptions.map((item) => {
          if (item.value >= 3600) {
            item.show = true;
          } else {
            item.show = false;
          }
        });
        this.dayJsFormat = 'MM-DD';
        this.selectOptionsValue = 86400;
      }
      // 时间超过一周
      if (timeDiff > 604800) {
        this.selectOptions.map((item) => {
          if (item.value <= 3600) {
            item.show = false;
          } else {
            item.show = true;
          }
        });
        this.dayJsFormat = 'MM-DD';
        this.selectOptionsValue = 86400;
      }
      // 时间超过一个月
      if (timeDiff > 2592000) {
        this.selectOptions.map((item) => {
          if (item.value < 86400) {
            item.show = false;
          } else {
            item.show = true;
          }
        });
        this.dayJsFormat = 'MM-DD';
        this.selectOptionsValue = 86400;
      }

      await this.filterTimeMargin();
      await this.getEchartsData();
    },

    /**
     * 递归处理返回的时间
     */
    filterTimeMargin() {
      const startTime = dayjs(this.pickerValue[0]).unix();
      const endTime = dayjs(this.pickerValue[1]).unix();
      const xAxisData = [dayjs(this.pickerValue[0]).unix()];
      for (let i = 1; (i * this.selectOptionsValue) + startTime < endTime; i++) {
        xAxisData.push(((i * this.selectOptionsValue) + startTime));
      }
      xAxisData.push(endTime);
      this.xAxisData = xAxisData;
    },

    /**
     * 处理返回的标准时间
     * @param val 标准时间
     */
    disposeTime(val) {
      return dayjs(val).format('HH:mm');
    },

    /**
     * 处理echarts
     * @param i id
     */
    siteMyLineChart(value, i) {
      return `${value}${i}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.echartsCollapse {
  height: 100%;
  overflow: auto;

  //::v-deep .el-collapse-item__wrap {
  //  overflow: auto;
  //}
  //
  //::v-deep .el-collapse {
  //  overflow: auto;
  //}
}

.select_width {
  width: 240px !important;
}

::v-deep .el-collapse-item__header {
  padding: 0 20px;
  border-bottom: 1px solid #eee;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0;
}


::v-deep .el-collapse-item__header:hover {
  background: rgb(236, 245, 255);
}

.echartsBox {
  height: 100%;
}


::v-deep .el-tabs__content {
  overflow: auto;
}
</style>
